var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.81773 0.852539L0.664062 3.00621L7.84373 10.1859L0.664062 17.3655L2.81773 19.5192L9.9974 12.3395L17.1771 19.5192L19.3307 17.3655L12.1511 10.1859L19.3307 3.00621L17.1771 0.852539L9.9974 8.03221L2.81773 0.852539Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseLg);
export default __webpack_public_path__ + "static/media/CloseLg.6ec0169041450bf5dc1ff9c2ba135bfb.svg";
export { ForwardRef as ReactComponent };